import { format } from 'date-fns'

import { Issues } from '@img-arena/consoles-api-streaming'

import { OtherCase } from './types'
import { EditableIssue } from './types'

export const editableToApi = (issue: EditableIssue) => {
  const { startDate, cases, ...rest } = issue

  return {
    ...rest,
    startDate: format(startDate, "yyyy-MM-dd'T'HH:mm:ssXX"),
    cases: cases === null ? {} : cases
  } as Issues
}

export const apiToEditable = (issue: Issues) => {
  const { startDate, cases, ...rest } = issue

  return {
    ...rest,
    startDate: new Date(startDate),
    cases: cases && Object.keys(cases).length > 0 ? cases : null
  } as EditableIssue
}

export const isOtherCase = (issueCase: Record<string, unknown>): issueCase is OtherCase =>
  'duration' in issueCase &&
  typeof issueCase.duration === 'string' &&
  'description' in issueCase &&
  typeof issueCase.description === 'string'
